<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="12" class="text-center">
				<h1>ISO Management System</h1>
				<p style="margin: 30px 50px;">An ISO management system connects policy to practice — from setting goals and defining roles,
					to embedding processes and managing risk, to reviewing progress and driving continuous improvement across the organisation.
				</p>
			</v-col>
			<v-tabs background-color="transparent" light centered icons-and-text v-model="selectedTab" @change="updateTab">
				<v-tab>
					Embedded in Management
					<span>1.</span>
				</v-tab>
				<v-tab>
					Implemented in Procedures & Processes
					<span>2.</span>
				</v-tab>
				<v-tab>
					Part of Everyday Operations
					<span>3.</span>
				</v-tab>
				<v-tab-item>
					<IsoEM />
				</v-tab-item>
				<v-tab-item>
					<IsoIPP />
				</v-tab-item>
				<v-tab-item>
					<IsoPEO />
				</v-tab-item>
			</v-tabs>
		</v-row>
	</v-container>
</template>

<script>
import IsoEM from "../components/IsoEM.vue"
import IsoIPP from "../components/IsoIPP.vue"
import IsoPEO from "../components/IsoPEO.vue"

export default {
	components: {
		IsoEM,
		IsoIPP,
		IsoPEO,
	},
	data() {
		return {
			selectedTab: 0,
		}
	},
	methods: {
		updateTab(tab) {
			const status = ["Embedded in Management", "Implemented in Procedures & Processes", "Part of Everyday Operations"][tab]
			this.$store.dispatch("updateSelectedStatus", status)
		},
	},
}
</script>
